module.exports = __webpack_public_path__ + "fonts/2e70cadb53958208cb952042e91b71a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/scenes/TripDetails/components/RegionSelect/img/icon_uk_selected.svg
// module id = 1524
// module chunks = 0